import type { Notice } from '../types/notice'

/**
 * Notices already created by the municipality. Titles are author-entered
 * content and therefore stay in the language they were written in.
 */
export const NOTICES: Notice[] = [
  {
    id: 'av-2041',
    title: "Avis d'ébullition d'eau préventif — secteur Traversier",
    category: 'eau',
    status: 'sent',
    date: '2026-08-18T07:30:00',
    endDate: '2026-08-21T18:00:00',
    audience: {
      kind: 'sector',
      count: 19320,
      detail: { fr: 'Secteurs A-B-E', en: 'Districts A-B-E' },
    },
    channels: ['email', 'sms', 'push', 'website'],
    stats: {
      recipients: 19320,
      delivered: 18974,
      openRate: 84,
      clickRate: 31,
      interactions: 2411,
      callsAvoided: 412,
      satisfaction: 4.6,
      channels: [
        { channel: 'push', sent: 16800, openRate: 89, clickRate: 34 },
        { channel: 'sms', sent: 14210, openRate: 94, clickRate: 22 },
        { channel: 'email', sent: 18974, openRate: 61, clickRate: 12 },
        { channel: 'website', sent: 0, openRate: 38, clickRate: 15 },
      ],
    },
  },
  {
    id: 'av-2038',
    title: 'Fermeture de la montée Sagala — travaux de réfection',
    category: 'travaux',
    status: 'sent',
    date: '2026-08-12T09:00:00',
    endDate: '2026-09-30T17:00:00',
    audience: {
      kind: 'location',
      count: 8600,
      detail: {
        fr: '155 montée Sagala · rayon 500 m',
        en: '155 montée Sagala · 500 m radius',
      },
    },
    channels: ['push', 'sms', 'social'],
    stats: {
      recipients: 8600,
      delivered: 8492,
      openRate: 79,
      clickRate: 26,
      interactions: 1104,
      callsAvoided: 188,
      satisfaction: 4.3,
      channels: [
        { channel: 'push', sent: 7560, openRate: 86, clickRate: 29 },
        { channel: 'sms', sent: 6310, openRate: 91, clickRate: 19 },
        { channel: 'social', sent: 0, openRate: 24, clickRate: 7 },
      ],
    },
  },
  {
    id: 'av-2035',
    title: 'Alerte météo majeure — vents violents',
    category: 'urgence',
    status: 'sent',
    date: '2026-07-28T16:45:00',
    audience: { kind: 'org', count: 91525 },
    channels: ['email', 'sms', 'voice', 'push', 'website', 'social', 'screens'],
    stats: {
      recipients: 91525,
      delivered: 89807,
      openRate: 91,
      clickRate: 18,
      interactions: 9840,
      callsAvoided: 1320,
      satisfaction: 4.8,
      channels: [
        { channel: 'push', sent: 80540, openRate: 93, clickRate: 21 },
        { channel: 'sms', sent: 86948, openRate: 96, clickRate: 14 },
        { channel: 'email', sent: 75050, openRate: 58, clickRate: 9 },
        { channel: 'voice', sent: 41186, openRate: 74, clickRate: 4 },
        { channel: 'website', sent: 0, openRate: 42, clickRate: 16 },
        { channel: 'social', sent: 0, openRate: 27, clickRate: 8 },
        { channel: 'screens', sent: 0, openRate: 31, clickRate: 0 },
      ],
    },
  },
  {
    id: 'av-2029',
    title: "Interruption temporaire du service d'eau — rue Forest",
    category: 'eau',
    status: 'sent',
    date: '2026-06-15T08:15:00',
    audience: {
      kind: 'location',
      count: 3200,
      detail: {
        fr: '1450 rue Forest · rayon 250 m',
        en: '1450 rue Forest · 250 m radius',
      },
    },
    channels: ['sms', 'push'],
    stats: {
      recipients: 3200,
      delivered: 3168,
      openRate: 88,
      clickRate: 12,
      interactions: 384,
      callsAvoided: 96,
      satisfaction: 4.4,
      channels: [
        { channel: 'push', sent: 2816, openRate: 90, clickRate: 14 },
        { channel: 'sms', sent: 2352, openRate: 95, clickRate: 9 },
      ],
    },
  },
  {
    id: 'av-2044',
    title: 'Collecte des encombrants — inscription requise',
    category: 'collecte',
    status: 'scheduled',
    date: '2026-09-02T06:00:00',
    endDate: '2026-09-09T20:00:00',
    audience: {
      kind: 'sector',
      count: 39400,
      detail: {
        fr: 'Secteurs N-O-S, P-R-T-V',
        en: 'Districts N-O-S, P-R-T-V',
      },
    },
    channels: ['email', 'push', 'website'],
  },
  {
    id: 'av-2046',
    title: 'Invitation — Fête de la famille de Windsor',
    category: 'evenement',
    status: 'scheduled',
    date: '2026-09-12T10:00:00',
    endDate: '2026-09-14T22:00:00',
    audience: {
      kind: 'filter',
      count: 22100,
      detail: {
        fr: 'Familles et jeunesse · Résidents',
        en: 'Families & youth · Residents',
      },
    },
    channels: ['email', 'push', 'social'],
  },
  {
    id: 'av-2048',
    title: 'Travaux de réfection — boulevard de l’Île',
    category: 'travaux',
    status: 'draft',
    date: '2026-08-25T00:00:00',
    endDate: '2026-10-15T17:00:00',
    audience: {
      kind: 'sector',
      count: 32805,
      detail: { fr: 'Secteurs C-I-J-L-M-X-Y', en: 'Districts C-I-J-L-M-X-Y' },
    },
    channels: ['email', 'push'],
  },
]
